import React from "react";
import { X, Download } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function VideoViewer({ videoUrl, onClose }) {
  const handleSave = async () => {
    try {
      const response = await fetch(videoUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `zd-golf-video-${Date.now()}.mp4`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("Видео сохранено");
    } catch (error) {
      toast.error("Ошибка сохранения");
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center"
      onClick={onClose}
      data-testid="video-viewer"
    >
      <div className="absolute top-4 right-4 left-4 flex justify-between z-10 safe-area-inset-top">
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="rounded-full bg-black/20 hover:bg-black/40 text-white"
          data-testid="close-viewer-btn"
        >
          <X className="w-6 h-6" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.stopPropagation();
            handleSave();
          }}
          className="rounded-full bg-black/20 hover:bg-black/40 text-white"
          data-testid="save-video-btn"
        >
          <Download className="w-6 h-6" />
        </Button>
      </div>
      <video
        src={videoUrl}
        controls
        autoPlay
        className="max-w-full max-h-full"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
